import ErrorResponse from './ErrorResponse';

export default ErrorResponse;
